import React, { useState } from 'react';
// import Gpay from './Gpay';
import './PriceCard.css';
// import Modal from 'react-bootstrap/Modal';
import Modal from './PopupModal';

const PriceCard = (props) => {
	const [modalShow, setModalShow] = useState(false);
	const [title, setTitle] = useState('');
	const [value, setValue] = useState(0);

	function showCheckout(e) {
		setTitle(e.target.id);
		setValue(e.target.value);

		setModalShow(true);
		console.log('price card ' + e.target.id + ' ' + e.target.value);
	}
	// console.log(props.details);
	return (
		<div className="pricing-back">
			<Modal
				show={modalShow}
				onHide={() => setModalShow(false)}
				title={title}
				price={value}
			/>{' '}
			<div className="pricing-table">
				<div className="pricing-card">
					<span></span>
					{/* <h3 className="pricing-card-header">Personal</h3> */}
					<h3
						className="pricing-card-header"
						dangerouslySetInnerHTML={{
							__html: props.details[0].name,
						}}
					/>
					<div className="price">
						<sup>$</sup>
						{props.details[0].price}
					</div>
					<ul>
						{props.details[0].details.map((user) => (
							<li
								key={user.id}
								className={user.className}
								dangerouslySetInnerHTML={{
									__html: user.detail,
								}}
							></li>
						))}
					</ul>
					<button
						className="order-btn"
						onClick={showCheckout}
						id={props.details[0].name}
						value={props.details[0].price}
					>
						Order Now
					</button>
					{/* <Gpay price={props.details[0].price} /> */}
				</div>

				<div className="pricing-card">
					<h3
						className="pricing-card-header"
						dangerouslySetInnerHTML={{
							__html: props.details[1].name,
						}}
					/>
					<div className="price">
						<sup>$</sup>
						{props.details[1].price}
					</div>
					<ul>
						{props.details[1].details.map((user) => (
							<li
								key={user.id}
								className={user.className}
								dangerouslySetInnerHTML={{
									__html: user.detail,
								}}
							></li>
						))}
					</ul>
					<button
						className="order-btn"
						onClick={showCheckout}
						id={props.details[1].name}
						value={props.details[1].price}
					>
						Order Now
					</button>

					{/* <Gpay price={props.details[1].price} /> */}
				</div>

				<div className="pricing-card">
					<h3
						className="pricing-card-header"
						dangerouslySetInnerHTML={{
							__html: props.details[2].name,
						}}
					/>
					<div className="price">
						<sup>$</sup>
						{props.details[2].price}
					</div>
					<ul>
						{props.details[2].details.map((user) => (
							<li
								key={user.id}
								className={user.className}
								dangerouslySetInnerHTML={{
									__html: user.detail,
								}}
							></li>
						))}
					</ul>
					<button
						className="order-btn"
						onClick={showCheckout}
						id={props.details[2].name}
						value={props.details[2].price}
					>
						Order Now
					</button>
					{/* <Gpay price={props.details[2].price} /> */}
				</div>

				<div className="pricing-card">
					<h3
						className="pricing-card-header"
						dangerouslySetInnerHTML={{
							__html: props.details[3].name,
						}}
					/>
					<div className="price">
						<sup>$</sup>
						{props.details[3].price}
					</div>
					<ul>
						{props.details[3].details.map((user) => (
							<li
								key={user.id}
								className={user.className}
								dangerouslySetInnerHTML={{
									__html: user.detail,
								}}
							></li>
						))}
					</ul>
					<button
						className="order-btn"
						onClick={showCheckout}
						id={props.details[3].name}
						value={props.details[3].price}
					>
						Order Now
					</button>
					{/* <Gpay price={props.details[3].price} /> */}
				</div>
			</div>
		</div>
	);
};

export default PriceCard;
